<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="处理结果：">
                <el-select v-model="searchForm.disposeState" clearable>
                    <el-option value="1" label="待审核"></el-option>
                    <el-option value="2" label="拒绝"></el-option>
                    <el-option value="3" label="通过"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="换卡类型">
                <el-select v-model="searchForm.changeCmccSim" clearable>
                    <el-option value="1" label="电信"></el-option>
                    <el-option value="2" label="移动"></el-option>
                    <el-option value="6" label="任意卡"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model="searchForm.takePhone"  @keyup.enter.native="getChangeCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="换卡ICCID号：">
                <el-input v-model="searchForm.oldIccid" @keyup.enter.native="getChangeCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="新ICCID号：">
                <el-input v-model="searchForm.newIccid" @keyup.enter.native="getChangeCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="申请时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain @click="getChangeCardListHandler" icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" plain @click="confirmExportDialogVisible = true"  icon="el-icon-download">导出Excel</el-button>
                <el-button type="primary" plain @click="showImportApply"   icon="el-icon-s-ticket">导入Excel</el-button>
                 <el-button type="primary" plain @click="showImportApply1"   icon="el-icon-s-ticket">导入卡数据</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>           
            <el-table-column  label="换卡ICCID号" width="170" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage({iccid:scope.row.oldIccid})">{{ scope.row.oldIccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="changeCmccSimName" label="新卡类型" width="90" align="center"></el-table-column>  
            <el-table-column prop="agencyName" label="层级关系" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="takeNickname" label="收货人姓名" width="90" align="center"></el-table-column>
            <el-table-column prop="takePhone" label="收货人电话" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="收货人地址" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.pcaAddress + scope.row.takeAddress}}
                </template>
            </el-table-column>
            <el-table-column prop="equipment" label="应用设备" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" width="140" align="center"></el-table-column>
            <el-table-column prop="newIccid" label="新ICCID号" width="170" align="center"></el-table-column>
            <el-table-column prop="disposeNickname" label="处理人" width="90" align="center"></el-table-column>
            <el-table-column prop="disposeTime" label="处理时间" width="140" align="center"></el-table-column>
            <el-table-column prop="disposeRemark" label="处理描述" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="disposeStateName" label="处理状态" width="90" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.disposeState == 1" type="text" size="small" @click="showDealWithChgCard(scope.row)">处理</el-button>
                </template>                  
            </el-table-column>
        </el-table>                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
			background
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="处理换卡" :visible.sync="dealWithVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="dealWithForm" :model="dealWithForm" :rules="dealWithRules" label-width="120px">
                <el-form-item label="换卡ICCID号：">
                    <span>{{ dealWithForm.oldIccid }}</span>
                </el-form-item>
                <el-form-item label="收货人姓名：" prop="takeNickname">
                    <el-input v-model="dealWithForm.takeNickname"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="takePhone">
                    <el-input v-model="dealWithForm.takePhone"></el-input>
                </el-form-item>
                <el-form-item label="地 址：" prop="pcaAddress">
                    <el-input v-model="dealWithForm.pcaAddress"></el-input>
                </el-form-item>
                <el-form-item label="详细地址：" prop="takeAddress">
                    <el-input v-model="dealWithForm.takeAddress"></el-input>
                </el-form-item>
                <el-form-item label="新ICCID号：" prop="newIccid">
                    <el-input v-model.trim="dealWithForm.newIccid"></el-input>
                </el-form-item>
                <el-form-item label="换卡类型:">
                    <el-radio-group v-model="dealWithForm.changeCmccSim" >
                        <el-radio :label="1">电信</el-radio>
                        <el-radio :label="2">移动</el-radio>
                        <el-radio :label="6">任意卡</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="处理结果：">
                    <el-radio-group v-model="dealWithForm.disposeState" @change="changeDisposeState">
                        <el-radio :label="3">通过</el-radio>
                        <el-radio :label="2">拒绝</el-radio>
                        <el-radio :label="1">待审核</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="处理详情：">
                    <el-input v-model.trim="dealWithForm.disposeRemark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureDealWithChgCardHandler">确 定</el-button>
            </div> 
        </el-dialog> 

        <el-dialog :append-to-body="true"  title="导入问题反馈" :visible.sync="importVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('applyChangeSim/export/changeSim')" :headers="setHeader()" :limit="1" :auto-upload="false" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>                        
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>



         <el-dialog :append-to-body="true"  title="导入数据" :visible.sync="importVisible1" width="600px" :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('batch/change/import/invent/sim')" :headers="setHeader()" :limit="1" :auto-upload="false" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>                        
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>
<script>
import {getChangeCardList, dealWithChangeCard} from '@/api/csm.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                disposeState: '',
                takePhone:'',
                oldIccid: '',
                newIccid: '',
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            dealWithVisible: false,
            dealWithForm: {
                id: '',
                oldIccid: '',
                takeNickname: '',
                takePhone: '',
                pcaAddress: '',
                takeAddress: '',
                newIccid: '',
                changeCmccSim: 1,
                disposeState: 3,
                disposeRemark: '',
            },
            rejectRules: {
                takeNickname: [{required:true, message: '请输入收件人姓名', trigger: 'blur'}],
                takePhone: [{required:true, validator: this.checkPhone, trigger: 'blur'}],
                takeAddress: [{required:true, message: '请输入收件人地址', trigger: 'blur'}]
            },
            agreeRules: {},
            importVisible: false,
            importVisible1: false,
            confirmExportDialogVisible:false//导出确认框
        }
    },
    computed: {
        dealWithRules(){
            // if(this.dealWithForm.disposeState == 2){
            //     return this.rejectRules;
            // }else{
            //     return this.agreeRules;
            // }             
        }
    },
    methods: {
        cancel(){
            this.dealWithVisible = false;    
            this.$refs.dealWithForm.resetFields();  
        },
        importCancel(){
            this.importVisible = false;
             this.importVisible1 = false;
        },
        getChangeCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getChangeCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        showDealWithChgCard(row){
            this.dealWithVisible = true;
            for(var key in this.dealWithForm){
                this.dealWithForm[key] = row[key]
                if(key == 'disposeState' && row[key] == 1){
                    this.dealWithForm[key] = 3
                }
            }
        },
        changeDisposeState(val){            
            if(val == 2){
                this.$refs.dealWithForm.fields[3].clearValidate()
            }
        },
        sureDealWithChgCardHandler(){
            this.$refs.dealWithForm.validate(valid => {
                if(valid){
                    var data = this.dealWithForm;
                    dealWithChangeCard(data).then(res => {
                        if(res.data.code == 200){
                            this.dealWithVisible = false;
                            this.getChangeCardListHandler();
                            this.$message.success(res.data.message);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importVisible1 = false;
                this.getChangeCardListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            } 
        },
        showImportApply(){
            this.importVisible = true;
        },
         showImportApply1(){
            this.importVisible1 = true;
        },
        importApplyHandler(){
            this.$refs.upload.submit();
        },
        exportApplyHandler(){
            var data = JSON.parse(JSON.stringify(this.searchForm));
            if(data.time != ''){
                data.startTimeString = data.time[0] + ' 00:00:00'; 
                data.endTimeString = data.time[1] + ' 23:59:59';
            }else{
                data.startTimeString = '';
                data.endTimeString = '';
            }
            delete data.time; 

            this.exportExcel('/mould/download/changeSim', data);
            this.confirmExportDialogVisible = false;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getChangeCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getChangeCardListHandler();
        }  
    },
    created () {
        this.getChangeCardListHandler();
        this.agreeRules = Object.assign({}, this.rejectRules, { newIccid: [{required:true, validator: this.checkIccid, trigger: 'blur'}] } )
    }
}
</script>
<style lang="less" scoped>

</style>

